<template>
  <rest-page ref="restPage" :fetch-endpoint="fetchEndpoint">
    <page-header-new :title="pageTitle" :breadcrumbs="breadcrumbs">
      <template v-slot:actions>
        <el-button
          type="primary"
          class="btn-connect btn-custom-icon"
          @click="save"
        >
          <icon class="icon" glyph="app-lightning" style="margin-right: 12px" />
          {{ $t('RestForm_Update') }}
        </el-button>
      </template>
    </page-header-new>
    <page-content>
      <rest-form ref="form" :save-endpoint="saveEndpoint" :model="model">
        <InboxMessageSettingsWeb
          :model="model"
          v-if="model && model.type === ApplicationTypes.web"
        />
        <InboxMessageSettingsAndroid
          :model="model"
          v-if="model && model.type === ApplicationTypes.android"
        />
        <InboxMessageSettingsIos
          :model="model"
          v-if="model && model.type === ApplicationTypes.ios"
        />
      </rest-form>
    </page-content>
  </rest-page>
</template>

<script>
import PageHeaderNew from '@/common/components/page/PageHeaderNew'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import { ApplicationTypes } from '@/modules/account/enum/ApplicationEnum'
import RestPage from '@/common/components/rest/RestPage'
import PageContent from '@/common/components/page/PageContent'
import InboxMessageSettingsWeb from '@/modules/settings/components/InboxMessageSettingsWeb'
import RestForm from '@/common/components/rest/RestForm'
import InboxMessageSettingsAndroid from '@/modules/settings/components/InboxMessageSettingsAndroid'
import InboxMessageSettingsIos from '@/modules/settings/components/InboxMessageSettingsIos'
export default {
  name: 'ApplicationInboxPage',
  components: {
    InboxMessageSettingsIos,
    InboxMessageSettingsAndroid,
    RestForm,
    InboxMessageSettingsWeb,
    PageContent,
    RestPage,
    PageHeaderNew
  },
  data() {
    return {
      ApplicationTypes,
      model: this.defaultModel()
    }
  },
  computed: {
    pageTitle() {
      return `${this.applicationName} - ${this.$t(this.$route.meta.title)}`
    },

    breadcrumbs() {
      return [
        {
          label: this.$t('ApplicationList_Title'),
          route: projectRoute({
            name: 'Applications'
          })
        },
        {
          label: this.applicationName,
          route: projectRoute({
            name: 'ApplicationChannels',
            query: {
              id: this.$route.query.id,
              project_id: this.$route.query.project_id
            }
          })
        },
        {
          label: this.$t(this.$route.meta.title)
        }
      ]
    },
    applicationName() {
      if (this.model && this.model.name) {
        return this.model.name
      }

      return this.$t('ApplicationsChannels_ActivationOk')
    },
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `applications/${this.$route.query.id}`,
        params: {
          expand: 'inbox_settings'
        },
        handler: data => {
          this.model = data
        }
      })
    },
    saveEndpoint() {
      if (this.$route.query.id) {
        return projectEndpoint({
          method: 'patch',
          url: `applications/${this.$route.query.id}`
        })
      }
    }
  },
  methods: {
    save() {
      this.$refs['form'].save()
    },
    defaultModel() {
      if (this.$route.query.id) {
        return null
      } else {
        return {
          type: this.$route.query.type,
          project_id: this.$route.query.project_id
        }
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/account/pages/ApplicationInboxPage.vue